import request from '@/utils/request';
import myRequest from '@/utils/myRequest'; // 导入推荐的请求实例

// 获取用户所有音乐
export const getMusicList = () => {
  console.log('调用获取音乐列表API');
  return myRequest({ // 使用 myRequest 替代 request
    url: '/api/music/list',
    method: 'get'
  });
};

// 获取用户上传的音乐
export const getMyUploadedMusic = () => {
  console.log('调用获取我上传的音乐列表API');
  return myRequest({
    url: '/api/music/my-uploads',
    method: 'get'
  });
};

// 管理员获取所有音乐
export const getAdminMusicList = () => {
  console.log('调用管理员获取所有音乐列表API');
  return myRequest({
    url: '/api/music/admin/list',
    method: 'get'
  });
};

// 获取歌曲的标签
export const getSongTags = (musicId) => {
  console.log(`获取歌曲(ID=${musicId})的标签`);
  return myRequest({
    url: `/api/music/${musicId}/tags`,
    method: 'get'
  });
};

// 批量获取用户所有歌曲的标签信息
// 一次性返回用户所有未删除歌曲的标签映射，大幅减少网络请求次数
export const getBatchSongTags = () => {
  console.log('🚀 [批量标签API] 开始批量获取所有歌曲标签');
  return myRequest({
    url: '/api/music/batch-tags',
    method: 'get'
  }).then(response => {
    console.log('🚀 [批量标签API] 批量获取标签成功，歌曲数量:', Object.keys(response).length);
    return response;
  }).catch(error => {
    console.error('🚀 [批量标签API] 批量获取标签失败:', error);
    throw error;
  });
};

// 上传音乐文件 - 改为支持多文件上传和进度监听
export const uploadMusic = (data, config = {}) => {
  console.log('开始调用上传音乐API');
  console.log('上传数据类型:', data instanceof FormData ? 'FormData' : typeof data);
  
  // 检查FormData内容
  if (data instanceof FormData) {
    try {
      console.log('FormData内容:');
      let files = [];
      let durations = new Map(); // 存储文件名与时长的映射
      
      for (let [key, value] of data.entries()) {
        if (value instanceof File) {
          console.log(`- ${key}: 文件 ${value.name} (${value.type}, ${Math.round(value.size/1024)}KB)`);
          files.push(value);
        } else {
          console.log(`- ${key}: ${value}`);
          // 检查是否是时长参数
          if (key.startsWith('duration_')) {
            const fileName = key.substring('duration_'.length);
            durations.set(fileName, parseInt(value));
            console.log(`- 检测到时长参数: ${fileName} -> ${value}秒`);
          }
        }
      }
      
      // 注意：不再在API层做多文件特殊处理，由前端控制上传流程
      // 这里只是记录一下文件信息，但不做特殊处理
    } catch (e) {
      console.error('无法读取FormData内容:', e);
    }
  }
  
  return myRequest({ // 使用 myRequest 替代 request
    url: '/api/music/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config // 传递配置，包括onUploadProgress
  }).then(response => {
    console.log('上传API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('上传API响应错误:', error);
    
    // 详细记录错误信息
    if (error.response) {
      console.error('服务器错误详情:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('未收到响应的请求详情:', error.request);
    }
    
    throw error; // 继续抛出错误以便上层处理
  });
};

// 批量删除音乐
export const deleteSongs = (songIds) => {
  return myRequest({
    url: '/api/music/batch',
    method: 'delete',
    data: { songIds }
  });
};

// 为音乐添加标签
export const addTagsToSongs = (data) => {
  return myRequest({
    url: '/api/music/tags',
    method: 'post',
    data
  });
};

// 从音乐中移除标签
export const removeTagFromSong = (songId, tagName) => {
  return myRequest({
    url: `/api/music/${songId}/tags/${encodeURIComponent(tagName)}`,
    method: 'delete'
  });
};

// 将歌曲添加到歌单
export const addSongsToPlaylist = (data) => {
  console.log(' [API] 调用addSongsToPlaylist，参数:', data);
  
  // 处理songIds，确保格式正确
  const songIds = Array.isArray(data.songIds) ? data.songIds : 
                 (data.songIds.map ? data.songIds.map(song => song.id) : []);
  
  // 处理特殊歌单ID
  const requestData = {
    songIds: songIds
  };
  
  // 如果playlistId是特殊字符串（如'favorite'），则传递歌单名称
  if (data.playlistId === 'favorite') {
    requestData.playlistName = '我喜欢的音乐';
    console.log(' [API] 检测到特殊歌单ID "favorite"，使用歌单名称: 我喜欢的音乐');
  } else {
    // 普通数字ID，直接传递
    requestData.playlistId = data.playlistId;
  }
  
  console.log(' [API] 最终请求数据:', requestData);
  
  return myRequest({
    url: '/api/music/playlist',
    method: 'post',
    data: requestData
  });
};

// 从歌单中移除歌曲
export const removeSongFromPlaylist = (playlistId, songId) => {
  return myRequest({
    url: `/api/playlists/${playlistId}/songs/${songId}`,
    method: 'delete'
  });
};

// 添加到收藏夹
export const addSongToFavorites = (songId) => {
  return myRequest({
    url: `/api/music/${songId}/favorite`,
    method: 'post'
  });
};

// 从收藏夹移除
export const removeSongFromFavorites = (songId) => {
  return myRequest({
    url: `/api/music/${songId}/favorite`,
    method: 'delete'
  });
};

// 将广场音乐保存到用户音乐库
export const saveToMusicLibrary = (songId) => {
  console.log('📚 调用保存音乐到用户库API:', songId);
  return myRequest({
    url: `/api/music/${songId}/save-to-library`,
    method: 'post'
  }).then(response => {
    console.log('📚 保存音乐到用户库API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('📚 保存音乐到用户库API失败:', error);
    throw error;
  });
};

// 快速分享音乐
export const quickShareMusic = (musicId, shareOptions = {}) => {
  console.log('📤 调用快速分享音乐API:', musicId, shareOptions);
  return myRequest({
    url: `/api/music/${musicId}/quick-share`,
    method: 'post',
    data: shareOptions
  }).then(response => {
    console.log('📤 快速分享音乐API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('📤 快速分享音乐API失败:', error);
    throw error;
  });
};

// 删除音乐分享
export const deleteMusicShare = (shareId) => {
  console.log('🗑️ 调用删除音乐分享API:', shareId);
  return myRequest({
    url: `/api/music/share/${shareId}`,
    method: 'delete'
  }).then(response => {
    console.log('🗑️ 删除音乐分享API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🗑️ 删除音乐分享API失败:', error);
    throw error;
  });
};

// 结束音乐分享（设置过期而不是删除）
export const endMusicShare = (shareId) => {
  console.log('⏹️ 调用结束音乐分享API:', shareId);
  return myRequest({
    url: `/api/music/share/${shareId}/end`,
    method: 'put'
  }).then(response => {
    console.log('⏹️ 结束音乐分享API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('⏹️ 结束音乐分享API失败:', error);
    throw error;
  });
};

// 结束批量分享（设置过期而不是删除）
export const endBatchShare = (shareId) => {
  console.log('⏹️ 调用结束批量分享API:', shareId);
  return myRequest({
    url: `/api/music/batch-share/${shareId}/end`,
    method: 'put'
  }).then(response => {
    console.log('⏹️ 结束批量分享API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('⏹️ 结束批量分享API失败:', error);
    throw error;
  });
};

// 获取分享音乐信息
export const getShareInfo = (shareId) => {
  console.log('🔗 调用获取分享信息API:', shareId);
  return myRequest({
    url: `/api/music/share/${shareId}`,
    method: 'get'
  }).then(response => {
    console.log('🔗 获取分享信息API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🔗 获取分享信息API失败:', error);
    throw error;
  });
};

// 验证分享密码
export const verifySharePassword = (shareId, password) => {
  console.log('🔐 调用验证分享密码API:', shareId);
  return myRequest({
    url: `/api/music/share/${shareId}/verify`,
    method: 'post',
    data: { password }
  }).then(response => {
    console.log('🔐 验证分享密码API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🔐 验证分享密码API失败:', error);
    throw error;
  });
};

// 获取分享音乐流地址
export const getShareStreamUrl = (shareId, password = null) => {
  const params = password ? `?password=${encodeURIComponent(password)}` : '';
  return `${myRequest.defaults.baseURL}/api/music/share/${shareId}/stream${params}`;
};

// 获取分享音乐下载地址
export const getShareDownloadUrl = (shareId, password = null) => {
  const params = password ? `?password=${encodeURIComponent(password)}` : '';
  return `${myRequest.defaults.baseURL}/api/music/share/${shareId}/download${params}`;
};

// 获取分享音乐云盘 CDN 直链（OneDrive / 阿里云盘）
export const getShareDirectUrl = async (shareId, password = null) => {
  try {
    console.log('🎵 获取分享音乐云盘 CDN 直链:', shareId);
    
    const params = password ? `?password=${encodeURIComponent(password)}` : '';
    const response = await myRequest.get(`/api/music/share/${shareId}/direct-url${params}`);
    
    console.log('✅ 获取分享音乐OneDrive CDN直链成功:', response);
    return response;
  } catch (error) {
    console.error('❌ 获取分享音乐OneDrive CDN直链失败:', error);
    throw error;
  }
};

// 批量分享音乐
export const batchShareMusic = (musicIds, shareOptions = {}) => {
  console.log('📤 调用批量分享音乐API:', musicIds, shareOptions);
  return myRequest({
    url: '/api/music/batch-share',
    method: 'post',
    data: {
      musicIds,
      ...shareOptions
    }
  }).then(response => {
    console.log('📤 批量分享音乐API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('📤 批量分享音乐API失败:', error);
    throw error;
  });
};

// 获取批量分享信息
export const getBatchShareInfo = (shareId) => {
  console.log('🔗 调用获取批量分享信息API:', shareId);
  return myRequest({
    url: `/api/music/batch-share/${shareId}`,
    method: 'get'
  }).then(response => {
    console.log('🔗 获取批量分享信息API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🔗 获取批量分享信息API失败:', error);
    throw error;
  });
};
export const removeFromMusicLibrary = (songId) => {
  console.log('📚 调用从用户库移除音乐API:', songId);
  return myRequest({
    url: `/api/music/${songId}/remove-from-library`,
    method: 'delete'
  }).then(response => {
    console.log('📚 从用户库移除音乐API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('📚 从用户库移除音乐API失败:', error);
    throw error;
  });
};

// 获取用户分享记录
export const getUserShareHistory = () => {
  console.log('📊 [分享记录] 调用获取用户分享记录API');
  return myRequest({
    url: '/api/music/share/history',
    method: 'get'
  }).then(response => {
    console.log('📊 [分享记录] 获取用户分享记录API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('📊 [分享记录] 获取用户分享记录API失败:', error);
    throw error;
  });
};

// 同步播放状态
export const syncPlaybackStatus = (songId, data) => {
  return myRequest({
    url: `/api/music/${songId}/status`,
    method: 'patch',
    data
  });
};

// 获取歌曲流
export const getSongStream = (id) => {
  return `${myRequest.defaults.baseURL}/api/music/${id}/stream`;
};

// 获取歌曲的MD5信息（用于缓存键生成）
export const getSongMD5 = (musicId) => {
  console.log(`获取歌曲(ID=${musicId})的MD5信息`);
  return myRequest({
    url: `/api/music/${musicId}/md5`,
    method: 'get'
  });
}; 

// 更新单首音乐时长
export const updateMusicDuration = (musicId) => {
  return myRequest({
    url: `/api/music/${musicId}/duration`,
    method: 'patch'
  });
};

// 批量更新音乐时长
export const updateMusicDurationBatch = (musicIds) => {
  return myRequest({
    url: '/api/music/batch/duration',
    method: 'patch',
    data: { musicIds }
  });
};

// 重命名音乐
export const renameMusic = (data) => {
  console.log('🎵 调用重命名音乐API，参数:', data);
  return myRequest({
    url: '/api/music/rename',
    method: 'post',
    data
  }).then(response => {
    console.log('🎵 重命名音乐API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🎵 重命名音乐API响应失败:', error);
    throw error;
  });
};

// 获取歌曲歌词
export const getSongLyrics = (musicId) => {
  console.log(`🎵 获取歌曲(ID=${musicId})的歌词`);
  return myRequest({
    url: `/api/music/${musicId}/lyrics`,
    method: 'get'
  }).then(response => {
    console.log('🎵 获取歌词API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🎵 获取歌词API响应失败:', error);
    throw error;
  });
};

// 爬虫批量上传音乐
export const crawlerBatchUpload = (formData, config = {}) => {
  console.log('🕷️ 开始调用爬虫批量上传API');
  console.log('🕷️ 上传数据类型:', formData instanceof FormData ? 'FormData' : typeof formData);
  
  if (formData instanceof FormData) {
    console.log('🕷️ FormData内容:');
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`🕷️ - ${key}: 文件 ${value.name} (${value.type}, ${Math.round(value.size/1024)}KB)`);
      } else {
        console.log(`🕷️ - ${key}: ${value}`);
      }
    }
  }
  
  return myRequest({
    url: '/api/music/crawler/batch-upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config // 传递配置，包括onUploadProgress
  }).then(response => {
    console.log('🕷️ 爬虫批量上传API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🕷️ 爬虫批量上传API响应错误:', error);
    
    // 详细记录错误信息
    if (error.response) {
      console.error('🕷️ 服务器错误详情:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('🕷️ 未收到响应的请求详情:', error.request);
    }
    
    throw error; // 继续抛出错误以便上层处理
  });
};

// 获取热门歌手列表
export const getHotSingers = () => {
  console.log('调用获取热门歌手列表API');
  return myRequest({
    url: '/api/music/hot-singers',
    method: 'get'
  }).then(response => {
    console.log('🎤 热门歌手API响应成功，歌手数量:', response.length);
    return response;
  }).catch(error => {
    console.error('🎤 获取热门歌手列表API失败:', error);
    throw error;
  });
};

// 获取指定歌手的歌曲列表
export const getSongsBySinger = (singerName) => {
  console.log('调用获取歌手歌曲列表API:', singerName);
  return myRequest({
    url: `/api/music/singer/${encodeURIComponent(singerName)}/songs`,
    method: 'get'
  }).then(response => {
    console.log('🎵 歌手歌曲列表API响应成功，歌曲数量:', response.length, '歌手:', singerName);
    return response;
  }).catch(error => {
    console.error('🎵 获取歌手歌曲列表API失败:', error, '歌手:', singerName);
    throw error;
  });
};

// 搜索广场音乐
export const searchCommonMusic = (keyword, limit = 100) => {
  console.log('调用搜索广场音乐API:', { keyword, limit });
  return myRequest({
    url: '/api/music/search',
    method: 'get',
    params: {
      keyword,
      limit
    }
  }).then(response => {
    console.log('🔍 搜索广场音乐API响应成功，结果数量:', response.length, '关键词:', keyword);
    return response;
  }).catch(error => {
    console.error('🔍 搜索广场音乐API失败:', error, '关键词:', keyword);
    throw error;
  });
};

// 搜索用户所有音乐（不受排序限制）
export const searchUserMusic = (keyword, limit = 1000) => {
  console.log('🔍 调用搜索用户所有音乐API:', { keyword, limit });
  return myRequest({
    url: '/api/music/search-user',
    method: 'get',
    params: {
      keyword,
      limit
    }
  }).then(response => {
    console.log('🔍 搜索用户所有音乐API响应成功，结果数量:', response.length, '关键词:', keyword);
    return response;
  }).catch(error => {
    console.error('🔍 搜索用户所有音乐API失败:', error, '关键词:', keyword);
    throw error;
  });
};

// 单个爬虫文件夹上传
export const uploadSingleCrawlerFolder = (formData, config = {}) => {
  console.log('🕷️ 开始调用单个爬虫文件夹上传API');
  console.log('🕷️ 上传数据类型:', formData instanceof FormData ? 'FormData' : typeof formData);
  
  if (formData instanceof FormData) {
    console.log('🕷️ FormData内容:');
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`🕷️ - ${key}: 文件 ${value.name} (${value.type}, ${Math.round(value.size/1024)}KB)`);
      } else {
        console.log(`🕷️ - ${key}: ${value}`);
      }
    }
  }
  
  return myRequest({
    url: '/api/music/crawler/single-upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config // 传递配置，包括onUploadProgress
  }).then(response => {
    console.log('🕷️ 单个爬虫文件夹上传API响应成功:', response);
    return response;
  }).catch(error => {
    console.error('🕷️ 单个爬虫文件夹上传API响应错误:', error);
    
    // 详细记录错误信息
    if (error.response) {
      console.error('🕷️ 服务器错误详情:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('🕷️ 未收到响应的请求详情:', error.request);
    }
    
    throw error; // 继续抛出错误以便上层处理
  });
};

// 外部音乐搜索（33ve.com）
export const searchExternalMusic = (keyword, page = 1, size = 20) => {
  console.log('🌐 调用外部音乐搜索API:', { keyword, page, size });
  return myRequest({
    url: '/api/music/external/search',
    method: 'get',
    params: {
      keyword,
      page,
      size
    }
  }).then(response => {
    console.log('🌐 外部音乐搜索API响应成功，结果数量:', response.songs?.length || 0, '关键词:', keyword);
    return response;
  }).catch(error => {
    console.error('🌐 外部音乐搜索API失败:', error, '关键词:', keyword);
    throw error;
  });
};

// 获取外部音乐流地址
export const getExternalMusicStream = (songId) => {
  return `${myRequest.defaults.baseURL}/api/music/external/stream/${songId}`;
};

// 获取外部音乐歌词
export const getExternalMusicLyrics = (songId) => {
  console.log('🌐 获取外部音乐歌词:', songId);
  return myRequest({
    url: `/api/music/external/lyrics/${songId}`,
    method: 'get'
  }).then(response => {
    console.log('🌐 外部音乐歌词API响应成功:', songId);
    return response;
  }).catch(error => {
    console.error('🌐 外部音乐歌词API失败:', error, '歌曲ID:', songId);
    throw error;
  });
};

// 获取外部音乐的所有资源（包括播放链接、封面、歌词等）
export const getExternalMusicResources = (songId) => {
  console.log('🌐 获取外部音乐所有资源:', songId);
  return myRequest({
    url: `/api/music/external/resources/${songId}`,
    method: 'get'
  }).then(response => {
    console.log('🌐 外部音乐资源API响应成功:', songId, response);
    return response;
  }).catch(error => {
    console.error('🌐 外部音乐资源API失败:', error, '歌曲ID:', songId);
    throw error;
  });
};

// 保存分享链接到I Music账号
export const saveShareUrlToIMusic = (shareUrl) => {
  console.log('🎵 [保存到I Music API] 开始保存分享链接:', shareUrl);
  return myRequest({
    url: '/api/music/share/save-share-url',
    method: 'post',
    data: {
      shareUrl: shareUrl
    }
  }).then(response => {
    console.log('🎵 [保存到I Music API] 保存成功:', response);
    return response;
  }).catch(error => {
    console.error('❌ [保存到I Music API] 保存失败:', error);
    throw error;
  });
};

// 保存视频信息到音乐
export const saveVideoToMusic = (musicId, videoData) => {
  console.log('🎬 [保存视频到音乐API] 开始保存视频信息:', { musicId, videoData });
  return myRequest({
    url: '/api/music/save-video-to-music',
    method: 'post',
    data: {
      musicId: musicId,
      videoData: videoData
    }
  }).then(response => {
    console.log('🎬 [保存视频到音乐API] 保存成功:', response);
    return response;
  }).catch(error => {
    console.error('❌ [保存视频到音乐API] 保存失败:', error);
    throw error;
  });
}; 